"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marginStyles = void 0;

const setWidth = (props, widthValue) => {
  if (widthValue) {
    return widthValue;
  }

  if (props.fullWidth) {
    if (props.marginHorizontal || props.marginHorizontal === 0) {
      return `calc(100% - ${props.marginHorizontal * 2}px)`;
    }
  }
};

const marginStyles = (props, widthValue) => {
  const styles = {
    width: setWidth(props, widthValue)
  };

  if (props.marginHorizontal || props.marginHorizontal === 0) {
    styles.marginLeft = `${props.marginHorizontal}px`;
    styles.marginRight = `${props.marginHorizontal}px`;
  }

  if (props.marginVertical || props.marginVertical === 0) {
    styles.marginTop = `${props.marginVertical}px`;
    styles.marginBottom = `${props.marginVertical}px`;
  }

  if (props.marginTop || props.marginTop === 0) {
    styles.marginTop = `${props.marginTop}px`;
  }

  if (props.marginBottom || props.marginBottom === 0) {
    styles.marginBottom = `${props.marginBottom}px`;
  }

  return styles;
};

exports.marginStyles = marginStyles;